<app-filter-panel [fields]="fieldsConfig" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="input-field p-input-icon-right">
        <input pInputText placeholder="Razón" [(ngModel)]="filters.reason.value" (keydown.enter)="search()" class="w-full" />
        <i *ngIf="filters.reason.value" class="pi pi-times cursor-pointer" (click)="filters.reason.value = null; search()"></i>
    </span>

    <span class="input-field p-input-icon-right">
        <input pInputText placeholder="Nombre cliente" [(ngModel)]="filters.clientName.value" (keydown.enter)="search()" class="w-full" />
        <i *ngIf="filters.clientName.value" class="pi pi-times cursor-pointer" (click)="filters.clientName.value = null; search()"></i>
    </span>

    <span class="input-field p-input-icon-right">
        <input pInputText placeholder="Teléfono" [(ngModel)]="filters.clientPhone.value" (keydown.enter)="search()" class="w-full" />
        <i *ngIf="filters.clientPhone.value" class="pi pi-times cursor-pointer" (click)="filters.clientPhone.value = null; search()"></i>
    </span>

    <span class="input-field p-input-icon-right">
        <input pInputText placeholder="Email" [(ngModel)]="filters.clientEmail.value" (keydown.enter)="search()" class="w-full" />
        <i *ngIf="filters.clientEmail.value" class="pi pi-times cursor-pointer" (click)="filters.clientEmail.value = null; search()"></i>
    </span>

    <button pButton label="Limpiar" icon="pi pi-eraser" severity="secondary" (click)="clearFilters()"></button>
</div>
-->

<p-table [value]="dataProtectionRequests" [lazy]="true" (onLazyLoad)="loadData($event)"
    [sortField]="'createdAt'" [sortOrder]="-1"
    [loading]="loading" [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25, 100, 250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="company.name">Compañía <p-sortIcon field="company.name"></p-sortIcon></th>
            <th pSortableColumn="from">Desde <p-sortIcon field="from"></p-sortIcon></th>
            <th pSortableColumn="to">Hasta <p-sortIcon field="to"></p-sortIcon></th>
            <th pSortableColumn="clientName">Cliente <p-sortIcon field="clientName"></p-sortIcon></th>
            <th pSortableColumn="clientPhone">Teléfono <p-sortIcon field="clientPhone"></p-sortIcon></th>
            <th pSortableColumn="clientEmail">Email <p-sortIcon field="clientEmail"></p-sortIcon></th>
            <th pSortableColumn="createdAt">Fecha creación <p-sortIcon field="createdAt"></p-sortIcon></th>
            <th pSortableColumn="createdByUser.userName">Creada por <p-sortIcon field="createdByUser.userName"></p-sortIcon></th>
            <th pSortableColumn="status">Estado <p-sortIcon field="status"></p-sortIcon></th>
            <th width="140"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-dataProtectionRequest>
        <tr>
            <td>{{ dataProtectionRequest.company?.name }}</td>
            <td>{{ dataProtectionRequest.from | date: 'dd/MM/yyyy' }}</td>
            <td>{{ dataProtectionRequest.to | date: 'dd/MM/yyyy' }}</td>
            <td>{{ dataProtectionRequest.clientName }}</td>
            <td>{{ dataProtectionRequest.clientPhone }}</td>
            <td>{{ dataProtectionRequest.clientEmail }}</td>
            <td>{{ dataProtectionRequest.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ dataProtectionRequest.createdByUser?.userName }}</td>
            <td>
                <p-tag [severity]="getStatusSeverity(dataProtectionRequest.status)"
                    [value]="getStatusLabel(dataProtectionRequest.status)"
                    [pTooltip]="dataProtectionRequest.status === 'error' && dataProtectionRequest.statusInfo ? dataProtectionRequest.statusInfo : ''"
                    tooltipPosition="top"></p-tag>
            </td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button (click)="downloadPdf(dataProtectionRequest)" [rounded]="true" [text]="false" severity="secondary" pTooltip="Abrir PDF"><i class="pi pi-file-pdf"></i></p-button>
                    <p-button *ngIf="allowDelete" (click)="delete(dataProtectionRequest)" [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog *ngIf="allowWrite" header="Nueva solicitud de protección de datos" [(visible)]="showCreateModal" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="{ width: '95vw', maxWidth: '1400px' }" appendTo="body"
    (onHide)="closeCreateModal()">
    <app-data-protection-detail *ngIf="showCreateModal" [embeddedInModal]="true"></app-data-protection-detail>
</p-dialog>

<p-confirmDialog></p-confirmDialog>